import * as React from 'react';

const NotGettingRemindersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={25}
    viewBox="0 0 23 25"
    fill="#000"
  >
    <g data-name="Group 1706">
      <path
        data-name="Path 130"
        d="M11.5 25a4 4 0 01-3.975-3.795H9.3a2.21 2.21 0 004.4 0h1.774A4 4 0 0111.5 25zm-8.842-5.357a2.68 2.68 0 01-.209-5.349.223.223 0 00.2-.223V8.928a8.847 8.847 0 1117.692 0v5.143a.223.223 0 00.2.223 2.68 2.68 0 01-.209 5.349zM11.5 1.786a7.118 7.118 0 00-7.077 7.142v5.357a1.779 1.779 0 01-1.768 1.787.893.893 0 000 1.786h17.687a.893.893 0 000-1.786 1.78 1.78 0 01-1.768-1.787V8.928A7.118 7.118 0 0011.5 1.786z"
      />
      <g data-name="Group 348">
        <g data-name="Group 347">
          <path
            data-name="Path 238"
            d="M9.412 9.33l3.135 3.872a.653.653 0 101.016-.823l-3.139-3.875a.653.653 0 10-1.016.822z"
          />
        </g>
      </g>
      <g data-name="Group 1701">
        <g data-name="Group 347">
          <path
            data-name="Path 238"
            d="M12.99 8.462l-3.523 3.523a.653.653 0 10.924.924l3.526-3.526a.653.653 0 10-.924-.924z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default NotGettingRemindersIcon;
